import React from 'react';

// Small inline "Beta" tag rendered next to gated affordances.
const BetaBadge: React.FC<{ className?: string }> = ({ className }) => (
  <span
    className={`ap-beta-badge${className ? ` ${className}` : ''}`}
    title="Beta — work in progress, not yet hardened"
    style={{
      fontSize: '10px',
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      padding: '1px 5px',
      marginLeft: '6px',
      borderRadius: '4px',
      background: 'rgba(180, 130, 0, 0.18)',
      color: '#b48200',
    }}
  >
    Beta
  </span>
);

export default BetaBadge;
